import { render, staticRenderFns } from "./acknowledgementModal.vue?vue&type=template&id=0b8c3545&"
import script from "./acknowledgementModal.vue?vue&type=script&lang=js&"
export * from "./acknowledgementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports